<template>
  <div>
    <v-card :loading="this.loading" rounded="xl" elevation="5" class="mx-5 px-5 py-5 my-5">
      <v-card-title>
        {{ $t('change_password.title') }}
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field outlined v-model="oldPassword"
            :type="'password'"
            :rules="passwordRules"
            v-bind:label="$t('change_password.old_password')"
            append-icon="mdi-key-outline"
            v-on:keyup.enter="changePassword">
          </v-text-field>
          <v-text-field outlined v-model="newPassword"
            :type="'password'"
            :rules="passwordRules"
            v-bind:label="$t('change_password.new_password')"
            append-icon="mdi-key-outline"
            v-on:keyup.enter="changePassword">
          </v-text-field>
          <v-text-field outlined v-model="confirmPassword"
            :type="'password'"
            :rules="[matchingPasswords]"
            v-bind:label="$t('change_password.confirm_password')"
            append-icon="mdi-key-outline"
            v-on:keyup.enter="changePassword">
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="mx-5 d-flex justify-end">
        <v-btn color="primary" @click="changePassword">
          {{ $t('change_password.action_change') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar color="error" v-model="showError">
      {{ errorText }}
    </v-snackbar>
    <v-snackbar color="success" v-model="showSuccess">
      {{ $t('change_password.password_changed') }}
    </v-snackbar>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'

import ChangePasswordService from '@/services/user/ChangePasswordService'

export default {
  name: 'ChangePassword',
  data: () => ({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    loading: false,
    passwordRules: [
      v => !!v || i18n.t('change_password.password_required')
    ],
    showError: false,
    errorText: '',
    showSuccess: false
  }),
  methods: {
    changePassword () {
      if (this.loading || !this.$refs.form.validate()) {
        return
      }
      this.loading = true
      ChangePasswordService.changePassword(this.oldPassword, this.newPassword, this.confirmPassword).then(response => {
        this.loading = false
        this.oldPassword = ''
        this.newPassword = ''
        this.confirmPassword = ''
        this.$refs.form.resetValidation()
        this.showSuccess = true
      }, error => {
        this.loading = false
        if (error.response.data) {
          this.errorText = i18n.t('password_change_error_code.' + error.response.data)
          this.showError = true
        } else {
          this.errorText = i18n.t('change_password.general_error')
          this.showError = true
        }
      })
    },
    matchingPasswords () {
      if (this.newPassword === this.confirmPassword) {
        return true
      } else {
        return i18n.t('change_password.password_no_match')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/ChangePassword.vue